(function () {
  function initialise(root) {
    root.querySelectorAll('[data-preorder-countdown]').forEach(function (section) {
      if (section.dataset.initialised) return;
      section.dataset.initialised = 'true';
      var raw = section.dataset.opensAt || '';
      var target = /T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(raw) ? Date.parse(raw) : NaN;
      if (!Number.isFinite(target)) return;
      var clock = section.querySelector('[data-countdown-clock]');
      var status = section.querySelector('[data-countdown-status]');
      status.hidden = true;
      var timer;
      function tick() {
        if (!section.isConnected) { clearInterval(timer); return; }
        var seconds = Math.max(0, Math.ceil((target - Date.now()) / 1000));
        var days = Math.floor(seconds / 86400);
        section.querySelector('[data-countdown-days]').textContent = String(days).padStart(2, '0');
        section.querySelector('[data-countdown-hours]').textContent = String(Math.floor(seconds % 86400 / 3600)).padStart(2, '0');
        section.querySelector('[data-countdown-minutes]').textContent = String(Math.floor(seconds % 3600 / 60)).padStart(2, '0');
        section.querySelector('[data-countdown-seconds]').textContent = String(seconds % 60).padStart(2, '0');
        clock.hidden = false;
        if (!seconds) {
          status.textContent = 'The opening is approaching. Sign up for the announcement.';
          status.hidden = false;
          clearInterval(timer);
        }
      }
      timer = setInterval(tick, 1000);
      tick();
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
})();
